import { styled } from '@linaria/react';
import { Stack } from '@mantine/core';
import type { FloraAnnotation } from '../../../../containers/adherence/risk-analysis/risk-analysis.client.type';
import { useTranslation } from 'react-i18next';
import { skyDark, skyLight, skyTight } from '../../../../styles/design-tokens';
import { Icon } from '../../../../ui-library/icon/icon';
import { Text } from '../../../../ui-library/typography/typography';

type ThirtyDaySummarySectionProps = {
  floraAnnotations: FloraAnnotation | null | undefined;
};

export function ThirtyDaySummarySection({ floraAnnotations }: ThirtyDaySummarySectionProps) {
  const i18n = useTranslation();
  const thirtyDaySummary = floraAnnotations?.thirty_day_summary;

  return (
    <SectionCard>
      <Stack gap={12}>
        <SectionHeader>
          <Icon name="calendar_month" size={18} color={skyDark} style={{ flexShrink: 0, width: '18px' }} />
          <SectionTitle>{i18n.t('strategy.overview.sections.thirty_day_summary')}</SectionTitle>
        </SectionHeader>

        {thirtyDaySummary ? (
          <SummaryText>{thirtyDaySummary}</SummaryText>
        ) : (
          <EmptyState>
            <Icon name="info-circle" size={16} color={skyDark} />
            <Text size="small" color={skyDark}>
              {i18n.t('strategy.overview.empty_states.no_thirty_day_summary')}
            </Text>
          </EmptyState>
        )}
      </Stack>
    </SectionCard>
  );
}

const SectionCard = styled.div`
  background-color: ${skyTight};
  border-radius: 16px;
  padding: 20px;
  border: 1px solid ${skyLight};
  flex: 1;
  min-height: 200px;
  display: flex;
  flex-direction: column;
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
`;

const SectionTitle = styled.div`
  font-family: 'Figtree', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  text-align: left;
`;

const SummaryText = styled.div`
  font-family: 'Figtree', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #000000;
  white-space: pre-wrap;
  word-wrap: break-word;
`;

const EmptyState = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  background-color: white;
  border-radius: 8px;
  border: 1px dashed ${skyLight};
`;
